export async function goExternalChatUnlogin(loginId) {
    let urlObj = await $.postJSON('/api/Chat/GetExternalLinkUnlogin', { LoginId: loginId });
    openWindow(urlObj.Url);
}

export async function goExternalChat() {
    let urlObj = await $.postJSON('/api/Chat/GetExternalLink');
    openWindow(urlObj.Url);
}

function openWindow(url) {
    if (url) {
        window.open(url, ENVIRONMENT.CORDOVA ? '_system' : '_blank');
    } else {
        this.$router.push('/ErrorMsg');
    }
}